import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  parentIndex: number;
}

export default function AddOnsTable(props: Props) {
  const { t } = useTranslation();
  const name: any = `approvalable.documentPurchases.${props.parentIndex}.documentPurchaseAddOns`;
  const _values = HOCWatchValue({ keys: [name] });
  const data = _values[name];

  const columns = [
    {
      header: t('common:name'),
      accessorKey: 'guestName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 300,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  if (data.length) {
    return (
      <div style={{ width: '100%' }}>
        <TableEditableComponent
          columns={columns}
          data={data}
          dispatch={() => {}}
          disabled
          name={name}
        />
      </div>
    );
  }
  return null;
}
